export default __webpack_public_path__ + "static/media/benifit-two-icon.0718b12a.svg";